export default __webpack_public_path__ + "static/media/96.cb1c9262.gif";